<template src="./Dashboard.html"></template>
<script>
  export default {
    data () {
      return {}
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue